<script setup lang="ts">
import { ref } from 'vue'

import ToastContextHandler from '@fondof-ui/components/toast/ToastContextHandler.vue'
import type { ToastContext } from '@global-store/stores/toast'
import { ToastRoot } from 'radix-vue'

const open = ref(true)

const emits = defineEmits<{
  'update:context': [ToastContext]
}>()

const onContextUpdate = (context: ToastContext) => {
  emits('update:context', context)
}
</script>

<template>
  <ToastRoot
    v-slot="slotProps"
    v-model:open="open"
  >
    <ToastContextHandler
      v-bind="slotProps"
      @update:context="onContextUpdate"
    />
    <slot v-bind="slotProps" />
  </ToastRoot>
</template>
